import React from "react";
import { Helmet } from "_c/Helmet";
import { generateUrl } from "@/utils/cloudinary";
import { SITE_URL } from "@/misc/constants";
import { useTranslation } from "react-i18next";

export default ({ avatar, name }) => {
  const { t, ready } = useTranslation("client_profile", {
    useSuspense: false,
  });
  if (!ready) return null;
  return (
    <Helmet
      title={t("client_profile:seo.title", { name })}
      meta={[
        {
          property: "og:image",
          content: avatar
            ? generateUrl(avatar)
            : `${SITE_URL}/mockups/avatar_big.png`,
        },
        {
          name: "robots",
          content: "noindex",
        },
      ]}
    />
  );
};
